import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const WarimashiRate = props => {
  return <Dropdown.Static kubunKey='warimashi_rate' {...props} />
}
